<template>
  <div class="support-float">
    <p class="support-float__text">{{ $t('hai_bisogno_aiuto') }}</p>
    <p class="support-float__row">
      <a
        href="tel:800770272"
        class="support-float__btn"
        :aria-label="$t('CallMailSupportButtons.call_support')"
      >
        <b-icon icon="telephone-fill" aria-hidden="true"></b-icon>
      </a>
      <a
        :href="'mailto:' + mailAddress"
        class="support-float__btn"
        :aria-label="$t('CallMailSupportButtons.email_support')"
      >
        <b-icon icon="envelope-fill" aria-hidden="true"></b-icon>
      </a>
    </p>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "CallMailSupportButtons",
  data() {
    return {
      mailAddress: process.env.VUE_APP_SUPPORT_MAIL_ADDRESS,
    };
  },
  created() {},

  mounted() {},
};
</script>

